<div style="clear: both;">
  <form [formGroup]="formGroup">
      <kendo-grid [data]="docRevisionList" [pageSize]="15" [pageable]="true" [sortable]="true" (edit)="editHandler($event)" (cancel)="cancelHandler($event)" (save)="saveHandler($event)" (remove)="removeHandler($event)" (add)="addHandler($event)">
          <ng-template kendoPagerTemplate>
              <div class="k-pager-left">
                  <kendo-pager-info></kendo-pager-info>
              </div>
              <div class="k-pager-right">
                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                  <kendo-pager-input></kendo-pager-input>
                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
              </div>
          </ng-template>
          <ng-template kendoGridToolbarTemplate>
              <div class="k-grid-toolbar-content d-flex">
                  <div class="flex-grow-1 mat-panel-headerbar"></div>
                  <div class="pagination-container" style="width:25%;font-weight: bold;display: flex;float: right;"><span style="width:35%;" class="eip-mr-15 d-none d-md-block">Business Group :</span>
                      <div style="width:95%;">
                          <EIPAutoComplete [dataSource]='groupDropdown' [clearValue]='setclear' ShowTextValueField='N' TextField="group_Name"  ValueField="group_Id" [IsCascading]='true' WaterMarkText='Business Group *' (valueChange)='groupValueChange($event)' required>
                          </EIPAutoComplete>
                      </div>
                  </div>
                  <div class="divider-container d-none d-md-block" id="imgDivider">
                      <span></span>
                  </div>
                  <div class="pagination-container">
                      <p id="lblShowDetails">Show</p>
                      <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                      </kendo-pager-page-sizes>
                      <span>Items</span>
                  </div>
                  <div class="divider-container d-none d-md-block" id="imgDivider">
                      <span></span>
                  </div>
                  <div class="icons-container">
                      <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                      <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                          <div class="icon-wrap">
                              <button kendoGridAddCommand style="width: 100%;"><i class="fa fa-plus-circle" style="font-size: 21px;" matTooltip="Add" aria-hidden="true"></i>
                              </button>
                          </div>
                          <div class="icon-wrap" (click)="toggleFullscreen()">
                              <i class="fa " [ngClass]="enableFullscreen ? 'fa-compress': ' fa-expand'" aria-hidden="true" title="{{ !enableFullscreen ? 'Expand' : 'Collapse' }}"></i>
                              <span class="list-icon-name">{{ !enableFullscreen ? 'Expand' : 'Collapse' }}</span>
                          </div>
                      </div>
                  </div>
              </div>
          </ng-template>
          <kendo-grid-column title="Sl.No." filterable="false" [width]="60">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  {{rowIndex+1}}
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="stageDescription" title="Stage Description" [width]="200">
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div>
                      <mat-form-field>
                          <mat-label>Select Stage </mat-label>
                          <mat-select [disabled]="setDisable" required formControlName="stage">
                              <mat-option *ngFor="let data of stageDropdown" [value]="data.dedId">
                                  {{data.dedDescription}}
                              </mat-option>
                          </mat-select>
                      </mat-form-field>
                  </div>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column field="revisionNo" editor="numeric" title="Revision No" [width]="110">
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <div>
                      <mat-form-field>
                          <input matInput [readonly]="setDisable" type="text" formControlName="revision">
                      </mat-form-field>
                  </div>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Created By" field="created_By" [width]="110">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <span class="no-wrap" eipTooltip="{{dataItem.created_By}}" eipTooltipPosition="auto">{{dataItem.created_By}}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Created On" field="created_On" [width]="110">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <span class="no-wrap" eipTooltip="{{dataItem.created_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.created_On | date:'dd-MMM-yyyy'}}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Modified By" field="modified_By" [width]="110">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                  <span class="no-wrap" eipTooltip="{{dataItem.modified_By}}" eipTooltipPosition="auto">{{dataItem.modified_By}}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column title="Modified On" field="modified_On" [width]="110">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <span class="no-wrap" eipTooltip="{{dataItem.modified_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">{{dataItem.modified_On | date:'dd-MMM-yyyy'}}</span>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-column editor="boolean" title="Is Active" [width]="50">
              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <kendo-switch [onLabel]="'Yes'" [offLabel]="'No'" [checked]="dataItem.isActive" [disabled]="true" [size]="small"></kendo-switch>
              </ng-template>
              <ng-template kendoGridEditTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                  <kendo-switch [onLabel]="'Yes'" [disabled]="statusDisable" [offLabel]="'No'" [checked]="true" formControlName="active_status" [size]="small"></kendo-switch>
              </ng-template>
          </kendo-grid-column>
          <kendo-grid-command-column title="Action" width="100">
              <ng-template kendoGridCellTemplate let-isNew="isNew">
                  <span kendoGridEditCommand class="setEditIcon">
                      <i class="fa fa-pencil eip-link" title="Edit" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                  </span>
                  <span kendoGridRemoveCommand class="setSaveIcon">
                      <i class="fa fa-trash eip-link" title="Delete" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                  </span>
                  <span kendoGridSaveCommand class="setEditIcon">
                      <i class="fa fa-save eip-link" title="{{ isNew ? 'Add' : 'Update' }}" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                  </span>
                  <span kendoGridCancelCommand class="setSaveIcon">
                      <i class="fa fa-cancel eip-link" title="{{ isNew ? 'Discard changes' : 'Cancel' }}" aria-hidden="true" style="font-size: 1.25em; cursor: pointer;"></i>
                  </span>
              </ng-template>
          </kendo-grid-command-column>
      </kendo-grid>
  </form>
</div>